import {defineStore} from "pinia";
import {ref} from "vue";
import i18n from '../plugins/i18n.js';
import vuetify from "../plugins/vuetify";
import rtl from '@/assets/rtl.css'
import {useTheme} from "vuetify";

export const useStore = defineStore('useStore', {
    state: () => {
        return {
            theme: "light",
            direction: ref(true),
            currentLang: null,
            userRole: null,
            expiration : null,
            accessToken : null,
            refreshToken : null,
            merchantId:null,
            merchants:null,
            userRoles:null,
            userId:null,
            firstName:null,
            lastName: null,
            merchantName:null,
            merchantChilds: [],
            applyValidationMaxSPD:null,
            permision: null,
            forceTo: null
        }
    },
    actions: {
        setUser(data) {
            if (!data) return;
            this.userRole = data.userRole !== undefined && data.userRole !== null ? data.userRole : this.userRole;
            this.userId = data.userId || this.userId;
            if (!this.userId && data.accessToken) {
                try {
                    const payload = JSON.parse(atob(data.accessToken.split('.')[1]));
                    this.userId = payload.UserId || payload.userId || payload.sub;
                } catch (e) {}
            }
            this.expiration = data.expiration || this.expiration;
            this.accessToken = data.accessToken || this.accessToken;
            this.refreshToken = data.refreshToken || this.refreshToken;
            this.merchantId = data.merchantId || this.merchantId;
            this.merchants = data.merchants || this.merchants;
            this.userRoles = data.userRoles || this.userRoles;
            this.firstName = data.firstName || this.firstName;
            this.lastName = data.lastName || this.lastName;
            this.merchantName = data.merchantName || this.merchantName;
            this.merchantChilds = Array.isArray(data.merchantChilds) ? data.merchantChilds : [];
            this.applyValidationMaxSPD = data.applyValidationMaxSPD;
            this.permision = data.permision || this.permision;
            this.forceTo = data.forceTo;
        },
        changeLanguage(newLang) {
            // if (i18n.global.locale.value === newLang && !window.location.href.toLowerCase().includes('/signin')) {
            //     if (i18n.global.t('direction') === 'rtl') {
            //         // document.getElementsByTagName('head')[0].innerHTML += ('<link rel="stylesheet" type="text/css" data-rltsupport="true" href="/src/assets/rtl.css" media="all">')
            //     } else {
            //         //document.querySelectorAll('link[data-rltsupport="true"]').length>0? document.querySelectorAll('link[data-rltsupport="true"]')[0].remove():"";
            //     }
            //     return;
            // }


            this.currentLang = newLang;
            i18n.global.locale.value = newLang; // this.$i18n.locale == 'en' ? 'fa' : 'en';
            this.direction = i18n.global.t('direction') === 'rtl';
            vuetify.locale.current.value = newLang;
            // vuetify.locale.rtl.value = i18n.global.t('direction') === 'rtl';

            if (i18n.global.t('direction') === 'rtl') {
              //  document.getElementsByTagName('head')[0].innerHTML += ('<link rel="stylesheet" type="text/css" data-rltsupport="true" href="/src/assets/rtl.css" media="all">')
            } else {
               // document.querySelectorAll('link[data-rltsupport="true"]').length>0? document.querySelectorAll('link[data-rltsupport="true"]')[0].remove():"";
            }
        },
        changeDirection(dir) {
            this.direction = dir === 'rtl';
        },
        clearUser() {
            this.userRole = null;
            this.expiration = null;
            this.accessToken = null;
            this.refreshToken = null;
            this.merchantId = null;
            this.merchants = null;
            this.userRoles = null;
            this.userId = null;
            this.firstName = null;
            this.lastName = null;
            this.merchantName = null;
            this.merchantChilds = [];
            this.applyValidationMaxSPD = null;
            this.permision = null;
            this.forceTo = null;
        }
    },
    persist: {
        storage: localStorage, // data persists for offline usage and across sessions
    },
});
